import { render, staticRenderFns } from "./ConfettiStar.vue?vue&type=template&id=756f0514&lang=pug&"
import script from "./ConfettiStar.vue?vue&type=script&lang=js&"
export * from "./ConfettiStar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports